import { forwardRef } from "react";
import type { TextFieldProps } from "@mui/material";
import { BaseInputV2 } from "src/components/BaseInputV2/BaseInputV2.tsx";
import { BaseInputV2Adornment } from "src/components/BaseInputV2/BaseInputV2Adornment.tsx";
import { composeRefs } from "@exonn/hooks";
import { css } from "@emotion/react";

export const PickerTextField = forwardRef((props: TextFieldProps, ref) => {
  const {
    InputProps,
    onChange,
    value,
    className,
    onClick,
    onBlur,
    onFocus,
    inputRef,
    error,
    disabled,
    placeholder,
    defaultValue,
    style,
    inputProps,
    inputProps: { onKeyDown, onPaste, style: inputStyle, inputMode } = {},
  } = props;

  return (
    <div style={style} css={rootStyles}>
      <BaseInputV2
        startAdornment={
          <BaseInputV2Adornment isAction={true}>
            <i className={"icon-15-calendar"} />
          </BaseInputV2Adornment>
        }
        endAdornment={InputProps?.endAdornment}
        style={inputStyle}
        css={inputStyles}
        className={className}
        hasError={error}
        ref={composeRefs(inputProps?.ref, InputProps?.ref, inputRef)}
        // @ts-ignore
        value={value}
        inputProps={{
          style: underlyingInputStyle,
        }}
        // @ts-ignore
        defaultValue={defaultValue}
        // @ts-ignore
        onChange={onChange}
        onKeyDown={onKeyDown}
        onPaste={onPaste}
        inputMode={inputMode}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={onClick}
        disabled={disabled}
        placeholder={placeholder}
      />
    </div>
  );
});

const underlyingInputStyle = {
  paddingRight: 5,
};

const inputStyles = () => css`
  width: 100%;
  height: 100%;
`;

const rootStyles = css`
  position: relative;
  display: inline-block;
  width: 100%;
`;
